/* eslint-disable no-nested-ternary */
import {
  isVtiGiS,
} from '../../../services/common/utils'

const getInitialValues = (formData, storefrontData) => {
  const vti = {
    allowPhoneAds: false,
    allowMailAds: false,
    allowPersonalizedMarketing: false,
    acceptVehicleDifferences: false,
    acceptLimitationPeriodVti: false,
    acceptPrecontractualInformationVti: false,
    acceptPurchaseConditionsVti: false,
    acceptInsuranceDocuments: false,
    acceptFirstUsage: false,
  }
  return isVtiGiS(storefrontData)
    ? vti
    : {}
}

export default getInitialValues
